import React from "react";
import { useSelector } from "react-redux";
import Table from "../../../components/table/coreUiTable/Table";
import {
  XLSX,
  dataForTables,
  getFormattedData,
  getScopedSlots,
  makeColHeadersUnique
} from "../utils/dataForTables";
import { useIncreasedTableWidth } from "../hooks/useIncreasedTableWidth.js";

export const RevenueTable = () => {
  useIncreasedTableWidth(".table-wrapper.revenue-table .table-responsive");
  const { data, colHeaders, columns } = useSelector(
    (state) => state.multiLocation.allRevenue.tableInfo
  );

  /*extract currency symbol from columns first object*/
  let pattern = columns[1].numericFormat?.pattern;
  let currency = pattern && pattern.replace("0,0.00", "");

  let formattedData = getFormattedData(data, currency);
  let headers = makeColHeadersUnique(colHeaders);
  let scopedSlots = getScopedSlots(data, headers);

  return (
    <>
      <XLSX colHeaders={colHeaders} data={data} columns={columns} />
      <Table
        cName="revenueTable"
        overrideColumnCallback={(header, index) => ({
          _style: header === "Location" ? { width: "230px" } : {},
          label: colHeaders[index]
        })}
        table={{ data: formattedData, colHeaders: headers }}
        scopedSlots={scopedSlots}
        {...dataForTables}
      />
    </>
  );
};

export default RevenueTable;
